import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicNetworkDnsDomainTLDParamsRaw,
	type LWApiPublicNetworkDnsDomainTLDDetailsResultRaw,
} from '@liquidweb-dev/club-sauce/public/network/dns/domain/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const NETWORK_DNS_DOMAIN_TLD_DETAILS_QUERY_KEY =
	'/network/dns/domain/tldDetails';

const useTldDetails = (
	params: LWApiPublicNetworkDnsDomainTLDParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicNetworkDnsDomainTLDDetailsResultRaw,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [NETWORK_DNS_DOMAIN_TLD_DETAILS_QUERY_KEY, params],
		queryFn: () => api.network.dns.domain.apiRaw.tldDetails(params),
		...options,
	});

export default useTldDetails;
